import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Stepper, useToast } from '../../components/ui';
import RequerirPacienteId from '../../components/RequerirPacienteId';
import { useUsuario } from '../../context/UsuarioContext';
import { useBusquedaTurnos } from './useBusquedaTurnos';
import { claveDia } from '../../utils/fechas';
import PasoTipo from './PasoTipo';
import PasoNombre from './PasoNombre';
import PasoServicio from './PasoServicio';
import PasoFecha from './PasoFecha';
import PasoTurno from './PasoTurno';
import './Buscar.css';

const PASOS = ['Tipo de búsqueda', 'Fecha', 'Turno'];
const indicePaso = { tipo: 0, nombre: 0, servicio: 0, fecha: 1, turno: 2 };

export default function Buscar() {
  const { pacienteId } = useUsuario();
  const navigate = useNavigate();
  const { notify } = useToast();
  const { criterio, turnos, cargando, error, buscarPorMedico, buscarPorServicio, reiniciar } = useBusquedaTurnos(pacienteId);

  const [vista, setVista] = useState('tipo');
  const [fecha, setFecha] = useState(null);

  const reiniciarWizard = () => {
    setVista('tipo'); setFecha(null); reiniciar();
  };

  const onMedicoElegido = (m) => { buscarPorMedico(m); setVista('fecha'); };
  const onServicioElegido = (s) => { buscarPorServicio(s); setVista('fecha'); };

  const onReservado = (turno) => {
    notify(`Turno con ${turno.medico?.nombre} reservado correctamente.`, { title: '¡Turno reservado!' });
    navigate('/mis-turnos');
  };

  const volverDeFecha = () => setVista(criterio?.tipo === 'servicio' ? 'servicio' : 'nombre');
  const volverDeTurno = (accion) => (accion === 'reiniciar' ? reiniciarWizard() : setVista('fecha'));

  const turnosDeFecha = fecha ? turnos.filter((t) => claveDia(t.fechaYHora) === fecha) : [];

  return (
    <Container>
      <h1 className="buscar-center">Buscar un turno</h1>

      <RequerirPacienteId titulo="Necesitamos tu ID para buscar turnos">
        <Stepper pasos={PASOS} actual={indicePaso[vista]} />

        <div className="buscar-wizard">
          {vista === 'tipo' && (
            <PasoTipo onElegir={(t) => setVista(t)} />
          )}
          {vista === 'nombre' && (
            <PasoNombre onElegir={onMedicoElegido} onVolver={() => setVista('tipo')} />
          )}
          {vista === 'servicio' && (
            <PasoServicio onElegir={onServicioElegido} onVolver={() => setVista('tipo')} />
          )}
          {vista === 'fecha' && (
            <PasoFecha
              turnos={turnos}
              criterioLabel={criterio?.label}
              cargando={cargando}
              error={error}
              onElegir={(clave) => { setFecha(clave); setVista('turno'); }}
              onVolver={volverDeFecha}
            />
          )}
          {vista === 'turno' && (
            <PasoTurno
              turnos={turnosDeFecha}
              fecha={fecha}
              criterioLabel={criterio?.label}
              pacienteId={pacienteId}
              onVolver={volverDeTurno}
              onReservado={onReservado}
            />
          )}
        </div>
      </RequerirPacienteId>
    </Container>
  );
}